import { IPlayerGame } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";
import { GetPlayerPreviousGamesPayload } from '@grassrootly/api/gateways';

export const GetPlayersPreviousGamesAlt = async ({
  date_to,
  pid,
  limit = 10,
  offset = 0,
}: GetPlayerPreviousGamesPayload): Promise<IPlayerGame[]> => {
  const response = await server
    .from("player_games_view")
    .select([
      "group_name",
      "group_logo",
      "game_id",
      "game_type",
      "game_status",
      "game_datetime",
      "game_host_team_name",
      "game_visitor_team_name",
      "game_host_score",
      "game_visitor_score",
      "player_id",
      "player_attended",
      "player_rating",
      "player_outcome",
      "player_goals_scored",
      "player_assists_made",
      "player_position",
      "player_yellow_cards",
      "player_red_cards",
      "player_saves",
      "player_own_goals",
      "player_errors_leading_to_a_goal",
      "organization_logo",
      "season_summary",
      "host_team_logo",
      "visitor_team_logo",
    ].join(","))
    .eq("player_id", pid)
    .eq("player_attended", true)
    .lt("game_datetime", new Date().toISOString())
    .order("game_datetime", { ascending: false })
    .range(offset, offset + limit - 1);

  const games = withErrorCheck<IPlayerGame[]>(response as any) || [];
  
  // Ensure player_id is set for each game
  games.forEach((game) => (game.player_id = pid));

  return games;
};
